export const ROLE_UNDEFINED = "UNDEFINED";
